import React from 'react'
import Modal from 'react-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faClose } from '@fortawesome/free-solid-svg-icons'

function AlertModal({ open, onClose, panic }) {
  return (
    <Modal
      isOpen={open}
      onRequestClose={() => onClose(!open)}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        content: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          border: 'none',
          width: '40rem',
          height: '20rem',
          overflow: 'visible',
          background: '#FAF9F6',
          borderRadius: 15,
        },
      }}
    >
      {/* <button onClick={() => onClose(!open)}>
                <FontAwesomeIcon
                    icon={faClose}
                    className='h-14 absolute right-2 top-2'
                />
            </button> */}
      <br />
      <br />
      <FontAwesomeIcon
        icon={faInfoCircle}
        className={`h-20 w-full ${panic ? 'text-red-600' : 'text-yellow-400'}`}
      />
      <br />
      <br />
      <h1 className="text-5xl text-black self-center w-full text-center">
        {`¡Alerta de ${panic ? 'Pánico!' : 'Monitoreo!'}`}
      </h1>
    </Modal>
  )
}

export default AlertModal
